import './styles.css';
const Input = ({ type, placeHolder, onChange, onBlur, onFocus, value }) => {
  return (
    <input
      type={type}
      className='form-control mb-4'
      placeholder={placeHolder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
};

export default Input;
